function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { empty } from '../helpers/empty';

/**
 * Collection cache
 *
 * This helps us keep track of which collections have been created.
 *
 * Whenever we edit a document, we then check the collection cache to see which collections we should also update.
 */
class CollectionCache {
  constructor() {
    _defineProperty(this, "collections", void 0);

    this.collections = {};
  }

  getSWRKeysFromCollectionPath(path) {
    var _this$collections$pat;

    const isCollection = path.trim().split('/').filter(Boolean).length % 2 !== 0;

    if (!isCollection) {
      console.error(`[fuego-swr-keys-from-collection-path] error: Passed a path that was not a collection to useCollection: ${path}.`);
    }

    return ((_this$collections$pat = this.collections[path]) === null || _this$collections$pat === void 0 ? void 0 : _this$collections$pat.map(_ref => {
      let {
        key
      } = _ref;
      return (// if the queryString is undefined, take it out of the array
        key.filter(keyItem => typeof keyItem === 'string')
      );
    }).filter(Boolean)) ?? empty.array;
  }

  addCollectionToCache(path, queryString) {
    var _this$collections$pat2;

    const collectionAlreadyExistsInCache = (_this$collections$pat2 = this.collections[path]) === null || _this$collections$pat2 === void 0 ? void 0 : _this$collections$pat2.some(_ref2 => {
      let {
        key
      } = _ref2;
      return key[0] === path && key[1] === queryString;
    });

    if (!collectionAlreadyExistsInCache) {
      this.collections = { ...this.collections,
        [path]: [...(this.collections[path] ?? empty.array), {
          key: [path, queryString]
        }]
      };
    }

    return this.collections;
  }

}

export const collectionCache = new CollectionCache();
//# sourceMappingURL=Cache.js.map